<template>
	<div class="contactBox" v-cloak>
		<ul>
			<li>
				<img src="../../../../static/img/contact1.png" alt="">
				<span>Service hotline</span>
				<p>{{field1}}</p>
			</li>
			<li>
				<img src="../../../../static/img/contact2.png" alt="">
				<span>Mail to us</span>
				<p>{{field2}}</p>
			</li>
			<li>
				<img src="../../../../static/img/contact3.png" alt="">
				<span>Weibo</span>
				<p>{{field3}}</p>
			</li>
			<li>
				<img src="../../../../static/img/contact4.png" alt="">
				<span>WeChat</span>
				<p>{{field4}}</p>
			</li>
			<li>
				<img src="../../../../static/img/contact5.png" alt="">
				<span>app</span>
				<p>{{field5}}</p>
			</li>
		</ul>

		<div class="contactDetail">
			<p><span>Business Cooperation </span>{{dic_name1_V}}</p>
			<p><span>Headoffice Address</span><span class="detContent">{{dic_name2_V}}</span></p>
			<p><span>Postcode </span>{{dic_name3_V}}</p>
		</div>

		<div class="bottomImgBox">
			<a href="https://720yun.com/t/58fjtdhaef8?scene_id=13072108" target="_blank">
				<img :src="img1" alt="">
				<p>VR</p>
			</a>
		</div>
		<div class="bottomImgBox">
				<img :src="img2" alt="">
				<p>Our schools</p>
		</div>

    <div class="homeBotTxt">
      <p>Copyright ©2018 Scholar Education</p>
      <div>
        <router-link to="/en/LegalDeclaration" @click.native="changeHeadNavList">Legal Notices</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default{
	data(){
		return{
			contactData: '',
			contactData2: '',
			contactData3: '',
			field1: '',
			field2: '',
			field3: '',
			field4: '',
			field5: '',
			dic_name1:'',
			dic_name1_V:'',
			dic_name2:'',
			dic_name2_V:'',
			dic_name3:'',
			dic_name3_V:'',
			img1:'',
			img2:'',
		}
	},
	created(){
		this.axios.get(this.$root.baseUrl+'/wap/aboutUs/contactUs')
		.then(res=>{
			this.contactData = res.data.contactUs1;
			this.contactData2 = res.data.contactUs2;
			this.contactData3 = res.data.imgUrlList;
			console.log(this.contactData3)
			this.field1 = this.contactData[0].field_desc;
			this.field2 = this.contactData[1].field_desc;
			this.field3 = this.contactData[2].field_desc4;
			this.field4 = this.contactData[3].field_desc4;
			this.field5 = this.contactData[4].field_desc4;

			this.dic_name1 = this.contactData2[0].dic_name;
			this.dic_name1_V = this.contactData2[0].field_desc;
			this.dic_name2 = this.contactData2[1].dic_name;
			this.dic_name2_V = this.contactData2[1].field_desc4;
			this.dic_name3 = this.contactData2[2].dic_name;
			this.dic_name3_V = this.contactData2[2].field_desc;

			this.img1 = this.contactData3[0].url;
			this.img2 = this.contactData3[1].url;
		})
		.catch(e=>{
			console.log(e)
		})
	}
}

</script>

<style scoped>
.contactBox{
    margin: 1.5rem 0 0;
	font-size: 0;
    padding: 1rem 1.06667rem;
	box-sizing: border-box;
}
.bottomImgBox{
    display: inline-block;
    width: 11.15rem;
    vertical-align: middle;
}
.bottomImgBox:nth-child(odd){
	margin-right: 0.3333rem;
}
.bottomImgBox img{
	display: inline-block;
	width: 100%;
    border-radius: 4px;
    box-shadow: 0 0 24px #e7ebf2;
}
.bottomImgBox p{
	text-align: center;
    font-size: 0.8rem;
    color: #333;
    line-height: 2rem;
}
ul{
    margin-bottom: 1.4rem;
    font-size: 1rem;
    padding: 0 0.7rem;
    box-sizing: border-box;
}
li{
    border-top: 1px solid #e6e6e6;
    height: 4.13333rem;
    line-height: 4.13333rem;
    font-size: 0;
}
li:nth-child(1){
	border:none;
}
li img{
    display: inline-block;
    vertical-align: middle;
    width: 1.066667rem;
    margin-right: 1.3333rem;
    /*height: 1.6rem;    */
}
li span{
	width: 6.2rem;
    display: inline-block;
    vertical-align: middle;
    font-size: 0.9333rem;
    color: #333;
}
li p{
	/*width: 10rem;*/
	display: inline-block;
    vertical-align: middle;
    color: #808080;
    font-size: 1rem;
}
.contactDetail{
    margin-bottom: 1.8rem;
    -webkit-box-shadow: 0 0 24px rgb(231, 235, 242);
    box-shadow: 0 0 24px rgb(231, 235, 242);
    padding: 1.6rem 1rem 0;
    font-size: 0.86667rem;
    color: #808080;
    border-radius: 4px;
}
.contactDetail span{
    width: 5.3rem;
    display: inline-block;
    vertical-align: top;
    font-size: 0.83333rem;
    font-weight: bold;
    color: #333;
    margin: 0 1rem 1rem 0;
}
.contactDetail .detContent{
    vertical-align: top;
    width: 11.6rem;
    color: #808080;
    font-weight: 400;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/components/en/about/contactBox.vue